<div class="form-row">
  <div class="form-group col-md-4">
    <label for="inputEmail4">Name</label>
    <input type="text" name='name' [(ngModel)]='this.product.name' [class.is-invalid]='!this.product.name' class="form-control" id="inputEmail4">
  </div>
  <div class="form-group col-md-4">
    <label for="inputEmail4">Display Name</label>
    <input type="text" name='name' [(ngModel)]='this.product.displayName' class="form-control" id="inputEmail4">
  </div>
  <div class="form-group col-md-4">
    <label for="inputPassword4">Unit</label>
    <select class='form-control' [class.is-invalid]='this.product.unitId === -1' (change)='this.product.unitId = +$event.target.value; this.product.unit.id = this.product.unitId'>
      <option value='-1'>Select a unit</option>
      @for (item of this.units; track item) {
        <option [value]='item.id' [selected]='this.product.unitId === item.id'>{{ item.name }}</option>
      }
    </select>
  </div>
  <div class="form-group col-md-4">
    <label>Stock owner</label>
    <select class='form-control' (change)='this.product.accountId = $event.target.value === "null" ? null : +$event.target.value'>
      <option value='null'>Not attributed</option>
      @for (account of this.accounts; track account.id) {
        <option [value]='account.id' [selected]='this.product.accountId === account.id'>{{ account.name }}</option>
      }
    </select>
    <small class='form-text text-muted'>
      Whose goods these are. Required before this product's stock can appear on a warehousing
      charge invoice &mdash; unattributed stock is reported, never billed.
    </small>
  </div>
  <div class="form-group col-md-4">
    <label for="inputEmail4">Price</label>
    <input type="number" name='name' [(ngModel)]='this.product.price' [class.is-invalid]='!this.product.price' class="form-control" id="inputEmail4">
  </div>
  <div class="form-group col-md-4">
    <!-- No is-invalid binding and no validator, unlike Price: 3PL stock is someone
         else's goods and carries a cost of zero, so blank or 0 is a real answer
         and must not read as a validation failure. -->
    <label for="inputCost">Cost</label>
    <input type="number" name='cost' [(ngModel)]='this.product.cost' class="form-control" id="inputCost">
  </div>
  <div class="form-group col-md-4">
    <label for="inputEmail4">Active</label>
    <input type="checkbox" name='name' [(ngModel)]='this.product.active' class="form-control" id="inputEmail4" value='1'>
  </div>
    <div class="form-group col-md-4">
    <label>Supplier Code (MPC): </label>
    <input type="text" name='supplierCode' [(ngModel)]="this.product.supplierCode" class="form-control">
  </div>
    <div class="form-group col-md-4">
    <!-- Single line, not a textarea: the scanner posts against the sku the product
         labels print, so a newline pasted in here would never match a scan. -->
    <label>Your Code (SKU) </label>
    <input type="text" name='sku' [(ngModel)]="this.product.sku" class="form-control">
  </div>
  <div class="form-group col-md-4">
    <label>Weight </label>
    <input type="number" name='weight' [(ngModel)]="this.product.weight" class="form-control">
  </div>
  <div class="form-group col-md-4">
    <label>Country of Origin</label>
    <input type="text" name='countryOfOrigin' [(ngModel)]="this.product.countryOfOrigin" class="form-control">
  </div>
  <div class="form-group col-md-4">
    <label>Product Class</label>
    <select class='form-control' (change)='this.product.productClassId = +$event.target.value'>
      <option value='-1'>Select a product class</option>
      @for (item of this.productClasses; track item) {
        <option [value]='item.id' [selected]='this.product.productClassId === item.id'>{{ item.name }}</option>
      }
    </select>
  </div>
  <div class="form-group col-md-4">
    <label>Product Group</label>
    <select class='form-control' (change)='this.product.productGroupId = +$event.target.value'>
      <option value='-1'>Select a product group</option>
      @for (item of this.productGroups; track item) {
        <option [value]='item.id' [selected]='this.product.productGroupId === item.id'>{{ item.name }}</option>
      }
    </select>
  </div>
  <div class="form-group col-md-4">
    <label>Default Warehouse Location</label>
    <select class='form-control' (change)='this.product.warehouseLocationId = +$event.target.value'>
      <option value='-1'>Select a location</option>
      @for (item of this.warehouseLocations; track item) {
        <option [value]='item.id' [selected]='this.product.warehouseLocationId === item.id'>{{ this.getLocationLabel(item) }}</option>
      }
    </select>
  </div>
    <div class="form-group col-md-12">
    <label>Description</label>
    <textarea [(ngModel)]="this.product.description" class="form-control"></textarea>
  </div>
</div>
